import { ArrowRight } from "lucide-react";

export function TextField({
  label,
  value,
  onChange,
  type = "text",
  testId,
  autoComplete,
  required,
  placeholder,
  icon: Icon,
}) {
  return (
    <label className="block">
      <span className="block text-[11px] uppercase tracking-[0.14em] text-neutral-400 mb-1.5">
        {label}
        {required && <span className="text-[#FF5A00] ml-1">*</span>}
      </span>
      <div className="relative">
        {Icon && (
          <Icon
            size={14}
            className="absolute left-3.5 top-1/2 -translate-y-1/2 text-neutral-500 pointer-events-none"
          />
        )}
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          autoComplete={autoComplete}
          placeholder={placeholder}
          data-testid={testId}
          className={`w-full bg-black/40 border border-white/10 rounded-xl ${
            Icon ? "pl-10" : "pl-4"
          } pr-4 py-3 text-white text-sm placeholder:text-neutral-600 focus:outline-none focus:border-[#FF5A00]/60 focus:ring-2 focus:ring-[#FF5A00]/20 transition`}
        />
      </div>
    </label>
  );
}

export function SelectField({ Icon, value, onChange, options, placeholder, testId }) {
  return (
    <div className="relative">
      {Icon && (
        <Icon
          size={14}
          className="absolute left-3.5 top-1/2 -translate-y-1/2 text-neutral-500 pointer-events-none z-10"
        />
      )}
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
        className="w-full appearance-none bg-black/40 border border-white/10 rounded-xl pl-10 pr-8 py-3 text-white text-sm focus:outline-none focus:border-[#FF5A00]/60 focus:ring-2 focus:ring-[#FF5A00]/20 transition"
      >
        <option value="" className="bg-[#0a0a0a]">
          {placeholder}
        </option>
        {options.map((o) => (
          <option key={o} value={o} className="bg-[#0a0a0a]">
            {o}
          </option>
        ))}
      </select>
      <ArrowRight
        size={12}
        className="absolute right-3 top-1/2 -translate-y-1/2 rotate-90 text-neutral-500 pointer-events-none"
      />
    </div>
  );
}
